/** @format */

import React, { useState, useEffect } from 'react'
import { formatCurrency, formatDate } from '../../../../../Helpers/formatters'
import localize from '../../../../../Global/Localize'
import BreadCrumb from '../../../../../Components/BreadCrumb/Index'
import { getData } from '../../../../../Helpers/webApi'
import Loader from '../../../../../Components/Loaders/Loader'
import EnumsServerCombo from '../../../../../Components/ComboBox/EnumsServerCombo'
import GroupedTable from '../../../../../Components/Tables/GroupedTable'
import Pager from '../../../../../Components/Tables/Pager'
import AddSalaryCardModal from './Partials/AddSalaryCardModal'
import EditSalaryCardModal from './Partials/EditSalaryCardModal'
import AddNewButton from '../../../../../Components/Buttons/AddNewButton/AddNewButton'

const Cards = () => {
  const columns = [
    {
      label: localize('cardNumber'),
      template: r => <>{r.paddedCardNumber}</>,
    },
    {
      label: localize('salaryGroup'),
      template: r => <>{r.salaryGroupDescription}</>,
    },
    {
      label: localize('employeeName'),
      template: r => <>{r.employeeCustomerFullName}</>,
    },
    {
      label: localize('account#'),
      template: r => <>{r.employeeCustomerReference1}</>,
    },
    {
      label: localize('membership#'),
      template: r => <>{r.employeeCustomerReference2}</>,
    },
    {
      label: localize('personalFile#'),
      template: r => <>{r.employeeCustomerReference3}</>,
    },
    {
      label: localize('nationality'),
      template: r => <>{r.employeeCustomerIndividualNationalityDescription}</>,
    },
    {
      label: localize('identityCardType'),
      template: r => (
        <>{r.employeeCustomerIndividualIdentityCardTypeDescription}</>
      ),
    },
    {
      label: localize('identityCardNumber'),
      template: r => <>{r.employeeCustomerIndividualIdentityCardNumber}</>,
    },
    {
      label: localize('gender'),
      template: r => <>{r.employeeCustomerIndividualGenderDescription}</>,
    },
    {
      label: localize('maritalStatus'),
      template: r => (
        <>{r.employeeCustomerIndividualMaritalStatusDescription}</>
      ),
    },
    {
      label: localize('serialNumber'),
      template: r => <>{r.paddedEmployeeCustomerSerialNumber}</>,
    },
    {
      label: localize('designation'),
      template: r => <>{r.employeeDesignationDescription}</>,
    },
    {
      label: localize('branch'),
      template: r => <>{r.employeeBranchDescription}</>,
    },
    {
      label: localize('department'),
      template: r => <>{r.employeeDepartmentDescription}</>,
    },
    {
      label: localize('employeeType'),
      template: r => <>{r.employeeEmployeeTypeDescription}</>,
    },
    {
      label: localize('bloodGroup'),
      template: r => <>{r.employeeBloodGroupDescription}</>,
    },
    {
      label: localize('nssfNumber'),
      template: r => <>{r.employeeNationalSocialSecurityFundNumber}</>,
    },
    {
      label: localize('nhifNumber'),
      template: r => <>{r.employeeNationalHospitalInsuranceFundNumber}</>,
    },
    {
      label: localize('pin'),
      template: r => <>{r.employeeCustomerPersonalIdentificationNumber}</>,
    },
    {
      label: localize('cardRemarks'),
      template: r => <>{r.remarks}</>,
    },
    {
      label: localize('isTaxExempt'),
      template: r => (
        <span className="text-capitalize">{r.isTaxExempt?.toString()}</span>
      ),
    },
    {
      label: localize('taxExemption'),
      template: r => <>{formatCurrency(r.taxExemption)}</>,
    },
    {
      label: localize('insuranceRelief'),
      template: r => <>{formatCurrency(r.insuranceReliefAmount)}</>,
    },
    {
      label: localize('mortageInterest'),
      template: r => <>{formatCurrency(r.mortageInterestAmount)}</>,
    },
    {
      label: localize('isLocked'),
      template: r => (
        <span className="text-capitalize">{r.isLocked?.toString()}</span>
      ),
    },
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r.createdDate)}</>,
    },
  ]
  const [isBusy, setIsBusy] = useState(false)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [reqParams, setReqParams] = useState({
    filterText: '',
    employeeFilter: 0,
    pageIndex: 0,
    pageSize: 10,
  })

  const [groupBy, setGroupBy] = useState({
    label: 'salaryGroup',
    value: 0,
    column: 'salaryGroupDescription',
  })
  const [selectedSalaryCard, setSelectedSalaryCard] = useState(null)
  const [mode, setMode] = useState(null)

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqParams.pageIndex, reqParams.pageSize])

  async function loadData() {
    setIsBusy(true)
    const { success, data } = await getData(
      '/SalaryCard/find-by-filter-in-page',
      reqParams,
      false
    )
    if (success) {
      setIsBusy(false)
      setData(data)
    } else {
      setIsBusy(false)
    }
  }
  const groupingColumns = [
    {
      value: 0,
      column: 'salaryGroupDescription',
    },
    {
      value: 1,
      column: 'employeeBranchDescription',
    },
    {
      value: 2,
      column: 'employeeDesignationDescription',
    },
    {
      value: 3,
      column: 'employeeDepartmentDescription',
    },
    {
      value: 4,
      column: 'employeeEmployeeTypeDescription',
    },
    {
      value: 5,
      column: 'employeeBloodGroupDescription',
    },
    {
      value: 6,
      column: 'employeeCustomerIndividualGenderDescription',
    },
    {
      value: 7,
      column: 'employeeCustomerIndividualMaritalStatusDescription',
    },
    {
      value: 8,
      column: 'employeeCustomerIndividualNationalityDescription',
    },
    {
      value: 9,
      column: 'employeeCustomerSalutationDescription',
    },
  ]

  const handleAddAction = () => {
    setMode('add')
  }

  return (
    <>
      <BreadCrumb
        tree={[localize('humanResourceManagement'), localize('salaryCards')]}
      />
      <div className="col-12">
        <div className="card bg-white">
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-4">
                <div className="mb-3">
                  <AddNewButton handleClickAddButton={handleAddAction} />
                </div>
              </div>
            </div>
            {isBusy ? (
              <Loader />
            ) : (
              <>
                <div className="row mb-2 mx-0">
                  <div className="d-flex align-items-center col-2">
                    <label
                      htmlFor="recordsPerPage"
                      className=""
                      style={{ marginLeft: -10, textTransform: 'capitalize' }}
                    >
                      {localize('recordsPerPage')}
                    </label>
                    <select
                      name=""
                      id="recordsPerPage"
                      className="form-select ms-1"
                      style={{ maxWidth: 'fit-content' }}
                      defaultValue={reqParams.pageSize}
                      onChange={e => {
                        setReqParams({
                          ...reqParams,
                          pageIndex: 0,
                          pageSize: e.target.value,
                        })
                      }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>

                  <div className="col-4 d-flex align-items-center">
                    <label className="col-3  text-capitalize">
                      {localize('groupBy')}
                    </label>
                    <EnumsServerCombo
                      sort
                      customContainerStyle={{
                        width: 150,
                        minWidth: 150,
                      }}
                      value={groupBy?.value}
                      enumsKey="SalaryCardPropertyGroup"
                      onChange={({ label, value }) =>
                        setGroupBy({
                          label,
                          value,
                          column: groupingColumns[value]?.column,
                        })
                      }
                    />
                  </div>

                  <form
                    className="d-flex align-items-center col-6 col"
                    onSubmit={e => {
                      e.preventDefault()
                      setReqParams({
                        ...reqParams,
                        text: search,
                      })
                    }}
                  >
                    <label
                      className="ms-2 me-1 text-capitalize"
                      htmlFor="searchTable"
                    >
                      {localize('search')}
                    </label>
                    <EnumsServerCombo
                      customContainerStyle={{ width: '100%' }}
                      value={reqParams?.employeeFilter}
                      enumsKey={'EmployeeFilter'}
                      onChange={e => {
                        setReqParams({
                          ...reqParams,
                          employeeFilter: e.value,
                        })
                      }}
                    />
                    <input
                      type="search"
                      id="searchTable"
                      className="form-control ms-2"
                      defaultValue={reqParams.filterText}
                      onChange={e => {
                        setSearch(e.target.value)
                        setReqParams({
                          ...reqParams,
                          filterText: e.target.value,
                        })
                      }}
                    />
                    <button
                      id="salaryCardFilterButton"
                      type="button"
                      className="btn btn-primary ms-1"
                      onClick={() => {
                        loadData()
                      }}
                    >
                      <i className="uil uil-filter"></i>
                    </button>
                  </form>
                </div>
                <GroupedTable
                  groupBy={groupBy}
                  columns={columns}
                  data={data?.pageCollection}
                  contextMenu={r => (
                    <>
                      <div
                        onClick={async () => {
                          setMode('edit')
                          setSelectedSalaryCard(r)
                        }}
                        className="ctxt-menu-item"
                      >
                        <i className="uil uil-edit-alt"></i>
                        {localize('edit')}
                      </div>
                    </>
                  )}
                />
                <div className="mb-2"></div>
                <Pager
                  itemsCount={data.itemsCount}
                  pageSize={reqParams.pageSize}
                  pageIndex={reqParams.pageIndex}
                  pageBatchSize={10}
                  onPageChange={p =>
                    setReqParams({ ...reqParams, pageIndex: p })
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>
      {mode === 'add' ? (
        <AddSalaryCardModal
          mode={mode}
          closeModal={() => {
            setMode(null)
            setSelectedSalaryCard(null)
          }}
          loadData={loadData}
        />
      ) : (
        ''
      )}
      {mode === 'edit' ? (
        <EditSalaryCardModal
          mode={mode}
          selectedSalaryCard={selectedSalaryCard}
          setSelectedSalaryCard={setSelectedSalaryCard}
          closeModal={() => {
            setMode(null)
            setSelectedSalaryCard(null)
          }}
          loadData={loadData}
        />
      ) : (
        ''
      )}
    </>
  )
}

export default Cards
